require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItem = exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _color = _interopRequireDefault(require("color"));

var React = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native-web/dist/index");

var _Icon = _interopRequireDefault(require("../Icon"));

var _TouchableRipple = _interopRequireDefault(require("../TouchableRipple"));

var _Text = _interopRequireDefault(require("../Typography/Text"));

var _theming = require("../../core/theming");

var _colors = require("../../styles/colors");

var _jsxFileName = "/Users/trensik/dev/react-native-paper/src/components/Menu/MenuItem.tsx";

var MenuItem = function (_React$Component) {
  (0, _inherits2["default"])(MenuItem, _React$Component);

  function MenuItem() {
    (0, _classCallCheck2["default"])(this, MenuItem);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(MenuItem).apply(this, arguments));
  }

  (0, _createClass2["default"])(MenuItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          icon = _this$props.icon,
          title = _this$props.title,
          disabled = _this$props.disabled,
          onPress = _this$props.onPress,
          theme = _this$props.theme,
          style = _this$props.style,
          testID = _this$props.testID,
          titleStyle = _this$props.titleStyle;
      var disabledColor = (0, _color["default"])(theme.dark ? _colors.white : _colors.black).alpha(0.32).rgb().string();
      var titleColor = disabled ? disabledColor : (0, _color["default"])(theme.colors.text).alpha(0.87).rgb().string();
      var iconColor = disabled ? disabledColor : (0, _color["default"])(theme.colors.text).alpha(0.54).rgb().string();
      return React.createElement(_TouchableRipple["default"], {
        style: [styles.container, style],
        onPress: onPress,
        disabled: disabled,
        testID: testID,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 86
        }
      }, React.createElement(_reactNative.View, {
        style: styles.row,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 92
        }
      }, icon ? React.createElement(_reactNative.View, {
        style: [styles.item, styles.icon],
        pointerEvents: "box-none",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 94
        }
      }, React.createElement(_Icon["default"], {
        source: icon,
        size: 24,
        color: iconColor,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 95
        }
      })) : null, React.createElement(_reactNative.View, {
        style: [styles.item, styles.content, icon ? styles.widthWithIcon : null],
        pointerEvents: "none",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 98
        }
      }, React.createElement(_Text["default"], {
        numberOfLines: 1,
        style: [styles.title, {
          color: titleColor
        }, titleStyle],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 106
        }
      }, title))));
    }
  }]);
  return MenuItem;
}(React.Component);

exports.MenuItem = MenuItem;
(0, _defineProperty2["default"])(MenuItem, "displayName", 'Menu.Item');
var minWidth = 112;
var maxWidth = 280;
var iconWidth = 40;

var styles = _reactNative.StyleSheet.create({
  container: {
    paddingHorizontal: 8,
    minWidth: minWidth,
    maxWidth: maxWidth,
    height: 48,
    justifyContent: 'center'
  },
  row: {
    flexDirection: 'row'
  },
  icon: {
    width: iconWidth
  },
  title: {
    fontSize: 16
  },
  item: {
    marginHorizontal: 8
  },
  content: {
    justifyContent: 'center',
    minWidth: minWidth - 16,
    maxWidth: maxWidth - 16
  },
  widthWithIcon: {
    maxWidth: maxWidth - (iconWidth + 48)
  }
});

var _default = (0, _theming.withTheme)(MenuItem);

exports["default"] = _default;